<div class="forbidden-page">
  <div class="forbidden-logo"></div>
  <h1>Nie masz wystarczających uprawnień</h1>
  <a routerLink="/" mat-flat-button color="primary">Wróć do strony głównej</a>
</div>
